import Categories from "../pages/categories/Categories";

function CategoriesRoutes() {
    return [
        {
            path: '/categories',
            element: <Categories />
        }
    ];
}

export default CategoriesRoutes;
